export default __webpack_public_path__ + "assets/images/4c038b114dd08099483cdf2c0f5d8bfc.png";